import { IChangeTracking } from "../../../changeTracking/iChangeTracking";

export class RequestConsignee implements IChangeTracking {
    private _current: any;

    constructor(private _model: any) {
        this._current = this._model ? angular.copy(this._model) : {};
    }

    get city(): string {
        return this._current.city;
    }

    set city(value: string) {
        this._current.city = value;
    }

    get consigneeName1(): string {
        return this._current.consigneeName1;
    }

    set consigneeName1(value: string) {
        this._current.consigneeName1 = value;
    }

    get consigneeName2(): string {
        return this._current.consigneeName2;
    }

    set consigneeName2(value: string) {
        this._current.consigneeName2 = value;
    }

    get consigneeName3(): string {
        return this._current.consigneeName3;
    }

    set consigneeName3(value: string) {
        this._current.consigneeName3 = value;
    }

    get consigneeName4(): string {
        return this._current.consigneeName4;
    }

    set consigneeName4(value: string) {
        this._current.consigneeName4 = value;
    }

    get consigneeStreet1(): string {
        return this._current.consigneeStreet1;
    }

    set consigneeStreet1(value: string) {
        this._current.consigneeStreet1 = value;
    }

    get consigneeStreet2(): string {
        return this._current.consigneeStreet2;
    }

    set consigneeStreet2(value: string) {
        this._current.consigneeStreet2 = value;
    }

    get consigneeStreet3(): string {
        return this._current.consigneeStreet3;
    }

    set consigneeStreet3(value: string) {
        this._current.consigneeStreet3 = value;
    }

    get consigneeStreet4(): string {
        return this._current.consigneeStreet4;
    }

    set consigneeStreet4(value: string) {
        this._current.consigneeStreet4 = value;
    }

    get consigneeHouseNumber(): string {
        return this._current.consigneeHouseNumber;
    }

    set consigneeHouseNumber(value: string) {
        this._current.consigneeHouseNumber = value;
    }

    

    get consigneeDistrict(): string {
        return this._current.consigneeDistrict;
    }

    set consigneeDistrict(value: string) {
        this._current.consigneeDistrict = value;
    }

    get consigneeAddressNumber(): string {
        return this._current.consigneeAddressNumber;
    }

    set consigneeAddressNumber(value: string) {
        this._current.consigneeAddressNumber = value;
    }

    get consigneeId(): string {
        return this._current.consigneeId;
    }
    set consigneeId(value: string) {
        this._current.consigneeId = value;
    }

    get consigneeName(): string {
        return this._current.consigneeName;
    }
    set consigneeName(value: string) {
        this._current.consigneeName = value;
    }

    get country(): string {
        return this._current.country;
    }

    set country(value: string) {
        this._current.country = value;
    }

    get countryCode(): string {
        return this._current.countryCode;
    }

    set countryCode(value: string) {
        this._current.countryCode = value;
    }

    get postalCode(): string {
        return this._current.postalCode;
    }

    set postalCode(value: string) {
        this._current.postalCode = value;
    }


    get regionCode(): string {
        return this._current.regionCode;
    }

    set regionCode(value: string) {
        this._current.regionCode = value;
    }

    get consigneeStreetAndHouseNumber(): string {
        return this.consigneeStreet1 + " " +
            ((this.consigneeHouseNumber !== undefined && this.consigneeHouseNumber !== null) ? this.consigneeHouseNumber : "");
    }

    get consigneeCityAndRegion(): string {
        return this.city +
            (this.regionCode !== undefined && this.regionCode !== null && this.regionCode.length > 0 ? ", " + this.regionCode : "");
    }

    

    get consigneePostalCodeAndCountry(): string {
        return this.postalCode + " " + this.country;
    }
    
    hasChanges(): boolean {
        return !angular.equals(this._current, this._model);
    }

    revert(): void {
        this._current = angular.copy(this._model);

    }

    commit(): void {
        this._model = angular.copy(this._current);
    }

    toJson(): any {

        return this._current;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/models/requestConsignee.ts
 **/